import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Ai\AiReportGenerationController::index
* @see Http/Controllers/Ai/AiReportGenerationController.php:19
* @route '/ai/transactions/reports/generations'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/ai/transactions/reports/generations',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Ai\AiReportGenerationController::index
* @see Http/Controllers/Ai/AiReportGenerationController.php:19
* @route '/ai/transactions/reports/generations'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Ai\AiReportGenerationController::index
* @see Http/Controllers/Ai/AiReportGenerationController.php:19
* @route '/ai/transactions/reports/generations'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Ai\AiReportGenerationController::index
* @see Http/Controllers/Ai/AiReportGenerationController.php:19
* @route '/ai/transactions/reports/generations'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Ai\AiReportGenerationController::show
* @see Http/Controllers/Ai/AiReportGenerationController.php:25
* @route '/ai/transactions/reports/generations/{generation}'
*/
export const show = (args: { generation: string | number } | [generation: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/ai/transactions/reports/generations/{generation}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Ai\AiReportGenerationController::show
* @see Http/Controllers/Ai/AiReportGenerationController.php:25
* @route '/ai/transactions/reports/generations/{generation}'
*/
show.url = (args: { generation: string | number } | [generation: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { generation: args }
    }

    if (Array.isArray(args)) {
        args = {
            generation: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        generation: args.generation,
    }

    return show.definition.url
            .replace('{generation}', parsedArgs.generation.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Ai\AiReportGenerationController::show
* @see Http/Controllers/Ai/AiReportGenerationController.php:25
* @route '/ai/transactions/reports/generations/{generation}'
*/
show.get = (args: { generation: string | number } | [generation: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Ai\AiReportGenerationController::show
* @see Http/Controllers/Ai/AiReportGenerationController.php:25
* @route '/ai/transactions/reports/generations/{generation}'
*/
show.head = (args: { generation: string | number } | [generation: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Ai\AiReportGenerationController::retry
* @see Http/Controllers/Ai/AiReportGenerationController.php:37
* @route '/ai/transactions/reports/generations/{generation}/retry'
*/
export const retry = (args: { generation: string | number } | [generation: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: retry.url(args, options),
    method: 'post',
})

retry.definition = {
    methods: ["post"],
    url: '/ai/transactions/reports/generations/{generation}/retry',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Ai\AiReportGenerationController::retry
* @see Http/Controllers/Ai/AiReportGenerationController.php:37
* @route '/ai/transactions/reports/generations/{generation}/retry'
*/
retry.url = (args: { generation: string | number } | [generation: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { generation: args }
    }

    if (Array.isArray(args)) {
        args = {
            generation: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        generation: args.generation,
    }

    return retry.definition.url
            .replace('{generation}', parsedArgs.generation.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Ai\AiReportGenerationController::retry
* @see Http/Controllers/Ai/AiReportGenerationController.php:37
* @route '/ai/transactions/reports/generations/{generation}/retry'
*/
retry.post = (args: { generation: string | number } | [generation: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: retry.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Ai\AiReportGenerationController::claimToast
* @see Http/Controllers/Ai/AiReportGenerationController.php:31
* @route '/ai/transactions/reports/generations/{generation}/claim-toast'
*/
export const claimToast = (args: { generation: string | number } | [generation: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: claimToast.url(args, options),
    method: 'post',
})

claimToast.definition = {
    methods: ["post"],
    url: '/ai/transactions/reports/generations/{generation}/claim-toast',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Ai\AiReportGenerationController::claimToast
* @see Http/Controllers/Ai/AiReportGenerationController.php:31
* @route '/ai/transactions/reports/generations/{generation}/claim-toast'
*/
claimToast.url = (args: { generation: string | number } | [generation: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { generation: args }
    }

    if (Array.isArray(args)) {
        args = {
            generation: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        generation: args.generation,
    }

    return claimToast.definition.url
            .replace('{generation}', parsedArgs.generation.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Ai\AiReportGenerationController::claimToast
* @see Http/Controllers/Ai/AiReportGenerationController.php:31
* @route '/ai/transactions/reports/generations/{generation}/claim-toast'
*/
claimToast.post = (args: { generation: string | number } | [generation: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: claimToast.url(args, options),
    method: 'post',
})

const generations = {
    index: Object.assign(index, index),
    show: Object.assign(show, show),
    retry: Object.assign(retry, retry),
    claimToast: Object.assign(claimToast, claimToast),
}

export default generations